/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ variant: NonNullable<unknown>, plan: NonNullable<unknown> }} Report_Line_PagesInputs */



/**
* | output |
* | --- |
* | "Pages {variant} ({plan})" |
*
* @param {Report_Line_PagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_line_pages = /** @type {((inputs: Report_Line_PagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Line_PagesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seiten ${i?.variant} (${i?.plan})`)
	return /** @type {LocalizedString} */ (`Pages ${i?.variant} (${i?.plan})`)
});